module.exports = __webpack_public_path__ + "static/media/blogpost1.b15758e6.jpg";